import React from "react";

const CustomerDetailsForm = ({ customerDetails, handleChange }) => {
  return (
    <div className="customer-box">
      <h4>Customer / Billing Details</h4>

      {/* Name Field */}
      <div className="form-group">
        <label htmlFor="customerName">Full Name</label>
        <input
          id="customerName"
          type="text"
          name="customerName"
          placeholder="Enter your name"
          value={customerDetails.customerName}
          onChange={handleChange}
          required
        />
      </div>

      {/* Mobile Field */}
   <div className="form-group">
  <label htmlFor="customerMobile">Mobile Number</label>
  <input
    id="customerMobile"
    type="tel"        // <-- Fix here
    name="customerMobile"
    placeholder="Enter mobile number"
    value={customerDetails.customerMobile}
    onChange={handleChange}
    maxLength={10}   // optional: prevent more than 10 digits
    required
  />
</div>


      {/* Email Field */}
      <div className="form-group">
        <label htmlFor="customerMailId">Email Address</label>
        <input
          id="customerMailId"
          type="email"
          name="customerMailId"
          placeholder="Enter email address"
          value={customerDetails.customerMailId}
          onChange={handleChange}
          required
        />
      </div>
    </div>
  );
};

export default CustomerDetailsForm;
